import { RootState } from 'app/store';

export const selectContracts = (state: RootState) => state.contracts.contracts;

export const selectContractGroup = (state: RootState) => state.contracts.group;

export const selectTotalPageCount = (state: RootState) =>
  state.contracts.totalPageCount;

export const selectContractsLoading = (state: RootState) =>
  state.contracts.loading;

export const selectContractsError = (state: RootState) => state.contracts.error;
